import {takeLatestF, putAll, showSuccess, extractFormErrorsFromResponse, NullableKeys} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {UpdateBreederBindingAdmin} from 'api/gen/UpdateBreederBindingAdmin';
import {t} from 'app/translations';
import {userDetailAction} from 'app/user-detail';
import {SubjectFacilityFormValues, subjectFacilityForm} from 'app/user-detail/types/subject-facility-form-values';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {UpdateBreederAction, adminAction} from '../action';

const te = t('common');
const title = te('updateEntry');

const buildValuesForApi =
    ({
        approvedTo,
        userProfileRoleIds,
    }: NullableKeys<SubjectFacilityFormValues>): UpdateBreederBindingAdmin => ({
        approvedTo: opt(approvedTo).orNull(),
        userProfileBreederRoleIds: opt(userProfileRoleIds)
            .orCrash('User member of subject edit: Required userProfileRoleIds found'),
    });

function* execute(_: UpdateBreederAction): SagaIterator {
    const formValues = (yield* select(formHelpers.formValues(subjectFacilityForm)))
        .orCrash(`no form values: ${subjectFacilityForm}`);
    yield* put(formHelpers.startSubmit(subjectFacilityForm));

    const response = yield* call(Api.updateUserProfileBreederRoleBindings, buildValuesForApi(formValues));

    if (response.isSuccess) {
        const userProfileId = opt(formValues.userProfileId).orCrash('No userProfileId found');

        yield* put(adminAction.getUserBreeders(opt({action: 'refresh'}), userProfileId));
        yield* put(showSuccess(title, te('updateEntrySuccess'), false, 'updateBreeder'));
        yield* put(userDetailAction.setFacilityModalVisible(null));
        yield* put(formHelpers.reset(subjectFacilityForm));
    } else {
        yield putAll(showBeError(response, title));
        yield* put(formHelpers.stopSubmit(subjectFacilityForm, extractFormErrorsFromResponse(response)));
    }
}

/** Runs the admin saga that updates breeder data from the admin form. */
export function* updateBreederSaga(): SagaIterator {
    yield takeLatestF('admin/UPDATE_BREEDER', execute);
}
